import type {HTMLAttributes} from 'react';

import {cn} from '@/lib/cn.js';

/**
 * A placeholder block shown while content loads.
 *
 * @param props Standard div props.
 * @returns The rendered skeleton.
 */
export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
